module.exports = __webpack_public_path__ + "static/media/pengumuman.3af4a856.svg";